import React, { useEffect, useMemo, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import Loader from "@/components/Loader";
import Link from "next/link";
import { Pagination } from "@/helpers/helperFunctions";
import { ExternalLinkIcon } from "lucide-react";
import { usePostMarketPlaceFilterAuthors } from "@/api/marketPlaceApi";
import { useTranslation } from "react-i18next";
import TraderCard from "../common/TraderCard";

const filtersAuthors = {
  sort_order: "app.trylevel2.com",
  total_strategies: "",
  copiers: "",
  trading_profile: "",
  win_p: "",
};

const buildFormData = (filters: Record<string, string>) => {
  const fd = new FormData();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null) fd.append(key, value);
  });
  return fd;
};

export default function TrendingTradres() {
  const { t } = useTranslation("marketplace-page");
  const { t: bt } = useTranslation("build-page");

  const [pageAuthors, setPageAuthors] = useState(1);
  const [authors, setAuthors] = useState<any[]>([]);
  const [total, setTotal] = useState(0);

  const formData = useMemo(() => buildFormData(filtersAuthors), []);

  const { data, isLoading, isSuccess } = usePostMarketPlaceFilterAuthors(
    formData,
    String(pageAuthors),
    "6",
  );

  useEffect(() => {
    if (isSuccess && data) {
      setAuthors(data.data.items || []);
      setTotal(data.data.total || 0);
    }
  }, [isSuccess, data]);

  return (
    <Card className="w-full h-full relative">
      <CardHeader className="flex !p-3 !px-3 justify-between flex-row items-center w-full pb-0">
        <CardTitle className="text-xl flex gap-0 items-start text-nowrap flex-col">
          {t("Top Traders")}
        </CardTitle>

        <Link
          href="/marketplace?showtraders=true"
          className="flex text-xs hover:underline text-[--accent-primary] font-medium"
        >
          {t("Explore More")} <ExternalLinkIcon className="h-[15px]" />
        </Link>
      </CardHeader>
      <p className="text-sm !px-3 pb-3 text-muted-foreground font-medium">
        {t("Get inspiration from top performers")}
      </p>

      {isLoading || authors.length === 0 ? (
        <div className="w-full flex items-center justify-center h-[200px]">
          {isLoading ? <Loader /> : t("No data found")}
        </div>
      ) : (
        <CardContent className="p-3 pt-0 h-[500px] overflow-auto">
          {/* 👇 Render TraderCard */}
          <div className="grid lg:grid-cols-2 xl:grid-cols-1 2xl:grid-cols-2 w-full gap-2 pt-4">
            {authors.map((item) => (
              <TraderCard key={item.user.email} item={item} animate />
            ))}
          </div>

          {/* Pagination */}
          <div className="mt-3 mb-10 sm:mb-0">
            <Pagination
              totalCount={total}
              currentPage={pageAuthors}
              changePage={setPageAuthors}
              limit={6}
            />
          </div>
        </CardContent>
      )}
    </Card>
  );
}
